import { render } from "./AssetSubType.vue?vue&type=template&id=1ee6a606&scoped=true"
import script from "./AssetSubType.vue?vue&type=script&lang=js"
export * from "./AssetSubType.vue?vue&type=script&lang=js"

import "./AssetSubType.vue?vue&type=style&index=0&id=1ee6a606&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\bocw_eticket_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ee6a606"]])

export default __exports__